<template>
  <li :class="classes">
    <router-link
      :to="topicSearchRoute"
      @click.prevent.stop="$emit('clicked-result', topic, 'Topic', locked)"
    >
      <div>
        <p
          v-if="rootTopic"
          class="root-topic-title"
          v-html="rootTopic.title"
        />
        <p
          class="topic-title"
          v-html="topic.title"
        />
        <p
          v-if="stripHtml(topic.content).length > 0"
          class="topic-content"
        >
          {{ stripHtml(topic.content) }}
        </p>
      </div>
      <icon
        v-if="locked"
        name="lock"
        variant="333333"
      />
    </router-link>
  </li>
</template>

<script>
import Icon from '@components/singletons/icon';

import GlobalMixin from '@/mixins/global';

import { stripHtml } from '@/utils';

export default {
  components: { Icon },
  mixins: [ GlobalMixin ],
  props: {
    classes: {
      type: String,
      default: '',
    },
    locked: {
      type: Boolean,
      default: false,
    },
    rootTopic: {
      type: Object,
      default: null,
    },
    topic: {
      type: Object,
    },
    topicSearchRoute: {
      type: Object,
    },
  },
  emits: ['clicked-result'],
  methods: {
    stripHtml,
  },
};
</script>

<style lang="scss" scoped>
li {
  margin-bottom: rem-calc(36);
  padding: rem-calc(16);

  @include breakpoint(small) {
    margin-bottom: rem-calc(24);
  }

  &.locked {
    opacity: 0.4;
  }

  &.tour {
    animation: blue-pulse 1.8s infinite;
  }

  &:not(.locked) {
    a {
      margin-right: rem-calc(42);

      .topic-title:hover {
        border-color: black;
      }
    }
  }
  a {
    align-items: center;
    color: #333333;
    display: flex;

    .root-topic-title {
      color: hlt-lighten(#333333, 40%);
      font-size: rem-calc(12);
      margin-top: 0;
      margin-bottom: rem-calc(4);
    }

    .topic-title {
      border-bottom: 1px solid transparent;
      color: black;
      display: inline-block;
      font-weight: $semi-bold;
      margin-top: 0;
      margin-bottom: rem-calc(4);
      font-size: rem-calc(20);
    }

    .topic-content,
    .topic-content p {
      display: -webkit-box;
      font-size: rem-calc(14);
      height: rem-calc(32);
      margin: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
    }

    img {
      height: rem-calc(18);
      width: rem-calc(18);
      padding-left: rem-calc(24);
      flex-shrink: 0;
    }
  }
}
</style>
